import { bookingActivityLogsDefaultQueryConfig } from "./modules/booking-activity-logs/booking-activity-logs-default-query";
import {
  selectBookingActivityLogById,
  selectBookingActivityLogQueryMap,
} from "./modules/booking-activity-logs/booking-activity-logs.selectors";
import { setBookingActivityLogQueryList } from "./modules/booking-activity-logs/booking-activity-logs.slice";
import { bookingDiscussionItemsDefaultQueryConfig } from "./modules/booking-discussion-items/booking-discussion-items-default-query";
import {
  selectBookingDiscussionItemById,
  selectBookingDiscussionItemQueryMap,
} from "./modules/booking-discussion-items/booking-discussion-items.selectors";
import { setBookingDiscussionItemQueryList } from "./modules/booking-discussion-items/booking-discussion-items.slice";
import { bookingsDefaultQueryConfig } from "./modules/bookings/bookings-default-query";
import {
  selectBookingById,
  selectBookingQueryMap,
} from "./modules/bookings/bookings.selectors";
import { setBookingQueryList } from "./modules/bookings/bookings.slice";
import { customerInvoicesDefaultQueryConfig } from "./modules/customer-invoices/customer-invoices-default-query";
import {
  selectCustomerInvoiceById,
  selectCustomerInvoiceQueryMap,
} from "./modules/customer-invoices/customer-invoices.selectors";
import { setCustomerInvoiceQueryList } from "./modules/customer-invoices/customer-invoices.slice";
import { profitAllocationRecordsDefaultQueryConfig } from "./modules/profit-allocation-records/profit-allocation-records-default-query";
import {
  selectProfitAllocationRecordById,
  selectProfitAllocationRecordQueryMap,
} from "./modules/profit-allocation-records/profit-allocation-records.selectors";
import { setProfitAllocationRecordQueryList } from "./modules/profit-allocation-records/profit-allocation-records.slice";
import { customerPaymentReceiptsDefaultQueryConfig } from "./modules/customer-payment-receipts/customer-payment-receipts-default-query";
import {
  selectCustomerPaymentReceiptById,
  selectCustomerPaymentReceiptQueryMap,
} from "./modules/customer-payment-receipts/customer-payment-receipts.selectors";
import { setCustomerPaymentReceiptQueryList } from "./modules/customer-payment-receipts/customer-payment-receipts.slice";
import { customerCreditVouchersDefaultQueryConfig } from "./modules/customer-credit-vouchers/customer-credit-vouchers-default-query";
import {
  selectCustomerCreditVoucherById,
  selectCustomerCreditVoucherQueryMap,
} from "./modules/customer-credit-vouchers/customer-credit-vouchers.selectors";
import { setCustomerCreditVoucherQueryList } from "./modules/customer-credit-vouchers/customer-credit-vouchers.slice";
import { supplierBillPaymentReceiptsDefaultQueryConfig } from "./modules/supplier-bill-payment-receipts/supplier-bill-payment-receipts-default-query";
import {
  selectSupplierBillPaymentReceiptById,
  selectSupplierBillPaymentReceiptQueryMap,
} from "./modules/supplier-bill-payment-receipts/supplier-bill-payment-receipts.selectors";
import { setSupplierBillPaymentReceiptQueryList } from "./modules/supplier-bill-payment-receipts/supplier-bill-payment-receipts.slice";
import { supplierBillsDefaultQueryConfig } from "./modules/supplier-bills/supplier-bills-default-query";
import {
  selectSupplierBillById,
  selectSupplierBillQueryMap,
} from "./modules/supplier-bills/supplier-bills.selectors";
import { setSupplierBillQueryList } from "./modules/supplier-bills/supplier-bills.slice";
import { combineEpics } from "redux-observable";
import { createEntityStateListMaintainerEpic } from "./epics/build-entity-list-state-maintainer-epic";
// import { conversationListStateMaintainerEpic } from "./epics/conversations/conversation-list-state-maintainer.epic";
import { notificationsEffects } from "./epics/notifications/notifications-emitter.epic";
// import { fbPostListStateMaintainerEpic } from "./epics/posts/posts-list-state-maintainer.epic";
// import { taskListStateMaintainerEpic } from "./epics/tasks/tasks-list-state-maintainer.epic";
import { userPresenceLoader } from "./epics/users/user-presence-loader.epic";


import { contactsDefaultQueryConfig } from "./modules/contacts/contacts-default-query";
import {
  selectContactById,
  selectContactQueryMap,
} from "./modules/contacts/contacts.selectors";
import { setContactsQueryList } from "./modules/contacts/contacts.slice";

import { opportunitiesDefaultQueryConfig } from "./modules/opportunities/opportunities-default-query";
import {
  selectOpportunityById,
  selectOpportunityQueryMap,
} from "./modules/opportunities/opportunities.selectors";
import { setOpportunitiesQueryList } from "./modules/opportunities/opportunities.slice";
import { tasksDefaultQueryConfig } from "./modules/tasks/tasks-default-query";
import {
  selectTaskById,
  selectTaskQueryMap,
} from "./modules/tasks/tasks.selectors";
import { setTaskQueryList } from "./modules/tasks/tasks.slice";
import { suppliersDefaultQueryConfig } from "./modules/suppliers/suppliers-default-query";
import {
  selectSupplierById,
  selectSupplierQueryMap,
} from "./modules/suppliers/suppliers.selectors";
import { setSupplierQueryList } from "./modules/suppliers/suppliers.slice";
import { customerPaymentMethodsDefaultQueryConfig } from "./modules/customer-payment-methods/customer-payment-methods-default-query";
import {
  selectCustomerPaymentMethodById,
  selectCustomerPaymentMethodQueryMap,
} from "./modules/customer-payment-methods/customer-payment-methods.selectors";
import { setCustomerPaymentMethodQueryList } from "./modules/customer-payment-methods/customer-payment-methods.slice";
import { supplierPaymentMethodsDefaultQueryConfig } from "./modules/supplier-payment-methods/supplier-payment-methods-default-query";
import {
  selectSupplierPaymentMethodById,
  selectSupplierPaymentMethodQueryMap,
} from "./modules/supplier-payment-methods/supplier-payment-methods.selectors";
import { setSupplierPaymentMethodQueryList } from "./modules/supplier-payment-methods/supplier-payment-methods.slice";
import { ledgersDefaultQueryConfig } from "./modules/ledgers/ledgers-default-query";
import {
  selectLedgerById,
  selectLedgerQueryMap,
} from "./modules/ledgers/ledgers.selectors";
import { setLedgerQueryList } from "./modules/ledgers/ledgers.slice";
import {
  selectLedgerTransactionById,
  selectLedgerTransactionQueryMap,
} from "./modules/ledger-transactions/ledger-transactions.selectors";
import { setLedgerTransactionQueryList } from "./modules/ledger-transactions/ledger-transactions.slice";
import { brandsDefaultQueryConfig } from "./modules/brands/brands-default-query";
import {
  selectBrandById,
  selectBrandQueryMap,
} from "./modules/brands/brands.selectors";
import { setBrandQueryList } from "./modules/brands/brands.slice";

const contactsListStateMaintainerEpic = createEntityStateListMaintainerEpic({
  entity: "contacts",
  selectEntityById: selectContactById,
  selectEntityQueryMap: selectContactQueryMap,
  setEntityQueryList: setContactsQueryList,
  otherAliasBuilder: () => ({
    all: contactsDefaultQueryConfig,
  }),
});

const taskListStateMaintainerEpic = createEntityStateListMaintainerEpic({
  entity: "tasks",
  selectEntityById: selectTaskById,
  selectEntityQueryMap: selectTaskQueryMap,
  setEntityQueryList: setTaskQueryList,
  otherAliasBuilder: () => ({
    all: tasksDefaultQueryConfig,
  }),
});

const opportunitiesListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "opportunities",
    selectEntityById: selectOpportunityById,
    selectEntityQueryMap: selectOpportunityQueryMap,
    setEntityQueryList: setOpportunitiesQueryList,
    otherAliasBuilder: () => ({
      all: opportunitiesDefaultQueryConfig,
    }),
  });

const bookingsListStateMaintainerEpic = createEntityStateListMaintainerEpic({
  entity: "bookings",
  selectEntityById: selectBookingById,
  selectEntityQueryMap: selectBookingQueryMap,
  setEntityQueryList: setBookingQueryList,
  otherAliasBuilder: () => ({
    all: bookingsDefaultQueryConfig,
  }),
});

const customerInvoicesListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "customerInvoices",
    selectEntityById: selectCustomerInvoiceById,
    selectEntityQueryMap: selectCustomerInvoiceQueryMap,
    setEntityQueryList: setCustomerInvoiceQueryList,
    otherAliasBuilder: () => ({
      all: customerInvoicesDefaultQueryConfig,
    }),
  });

const customerPaymentReceiptsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "customerPaymentReceipts",
    selectEntityById: selectCustomerPaymentReceiptById,
    selectEntityQueryMap: selectCustomerPaymentReceiptQueryMap,
    setEntityQueryList: setCustomerPaymentReceiptQueryList,
    otherAliasBuilder: () => ({
      all: customerPaymentReceiptsDefaultQueryConfig,
    }),
  });

const customerCreditVouchersListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "customerCreditVouchers",
    selectEntityById: selectCustomerCreditVoucherById,
    selectEntityQueryMap: selectCustomerCreditVoucherQueryMap,
    setEntityQueryList: setCustomerCreditVoucherQueryList,
    otherAliasBuilder: () => ({
      all: customerCreditVouchersDefaultQueryConfig,
    }),
  });

const profitAllocationRecordsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "profitAllocationRecords",
    selectEntityById: selectProfitAllocationRecordById,
    selectEntityQueryMap: selectProfitAllocationRecordQueryMap,
    setEntityQueryList: setProfitAllocationRecordQueryList,
    otherAliasBuilder: () => ({
      all: profitAllocationRecordsDefaultQueryConfig,
    }),
  });

const supplierBillsListStateMaintainerEpic = createEntityStateListMaintainerEpic({
  entity: "supplierBills",
  selectEntityById: selectSupplierBillById,
  selectEntityQueryMap: selectSupplierBillQueryMap,
  setEntityQueryList: setSupplierBillQueryList,
  otherAliasBuilder: () => ({
    all: supplierBillsDefaultQueryConfig,
  }),
});

const supplierBillPaymentReceiptsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "supplierBillPaymentReceipts",
    selectEntityById: selectSupplierBillPaymentReceiptById,
    selectEntityQueryMap: selectSupplierBillPaymentReceiptQueryMap,
    setEntityQueryList: setSupplierBillPaymentReceiptQueryList,
    otherAliasBuilder: () => ({
      all: supplierBillPaymentReceiptsDefaultQueryConfig,
    }),
  });

const bookingDiscussionItemsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "bookingDiscussionItems",
    selectEntityById: selectBookingDiscussionItemById,
    selectEntityQueryMap: selectBookingDiscussionItemQueryMap,
    setEntityQueryList: setBookingDiscussionItemQueryList,
    otherAliasBuilder: () => ({
      all: bookingDiscussionItemsDefaultQueryConfig,
    }),
  });

const bookingActivityLogsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "bookingActivityLogs",
    selectEntityById: selectBookingActivityLogById,
    selectEntityQueryMap: selectBookingActivityLogQueryMap,
    setEntityQueryList: setBookingActivityLogQueryList,
    otherAliasBuilder: () => ({
      all: bookingActivityLogsDefaultQueryConfig,
    }),
  });

const suppliersListStateMaintainerEpic = createEntityStateListMaintainerEpic({
  entity: "suppliers",
  selectEntityById: selectSupplierById,
  selectEntityQueryMap: selectSupplierQueryMap,
  setEntityQueryList: setSupplierQueryList,
  otherAliasBuilder: () => ({
    all: suppliersDefaultQueryConfig,
  }),
});

const customerPaymentMethodsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "customerPaymentMethods",
    selectEntityById: selectCustomerPaymentMethodById,
    selectEntityQueryMap: selectCustomerPaymentMethodQueryMap,
    setEntityQueryList: setCustomerPaymentMethodQueryList,
    otherAliasBuilder: () => ({
      all: customerPaymentMethodsDefaultQueryConfig,
    }),
  });

const supplierPaymentMethodsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "supplierPaymentMethods",
    selectEntityById: selectSupplierPaymentMethodById,
    selectEntityQueryMap: selectSupplierPaymentMethodQueryMap,
    setEntityQueryList: setSupplierPaymentMethodQueryList,
    otherAliasBuilder: () => ({
      all: supplierPaymentMethodsDefaultQueryConfig,
    }),
  });

const brandsListStateMaintainerEpic = createEntityStateListMaintainerEpic({
  entity: "brands",
  selectEntityById: selectBrandById,
  selectEntityQueryMap: selectBrandQueryMap,
  setEntityQueryList: setBrandQueryList,
  otherAliasBuilder: () => ({
    all: brandsDefaultQueryConfig,
  }),
});

const ledgersListStateMaintainerEpic = createEntityStateListMaintainerEpic({
  entity: "ledgers",
  selectEntityById: selectLedgerById,
  selectEntityQueryMap: selectLedgerQueryMap,
  setEntityQueryList: setLedgerQueryList,
  otherAliasBuilder: () => ({
    all: ledgersDefaultQueryConfig,
  }),
});

const ledgerTransactionsListStateMaintainerEpic =
  createEntityStateListMaintainerEpic({
    entity: "ledgerTransactions",
    selectEntityById: selectLedgerTransactionById,
    selectEntityQueryMap: selectLedgerTransactionQueryMap,
    setEntityQueryList: setLedgerTransactionQueryList,
  });

export default combineEpics(
  contactsListStateMaintainerEpic,
  userPresenceLoader,
  notificationsEffects,
  taskListStateMaintainerEpic,
  opportunitiesListStateMaintainerEpic,
  bookingsListStateMaintainerEpic,
  customerInvoicesListStateMaintainerEpic,
  customerPaymentReceiptsListStateMaintainerEpic,
  customerCreditVouchersListStateMaintainerEpic,
  profitAllocationRecordsListStateMaintainerEpic,
  supplierBillsListStateMaintainerEpic,
  supplierBillPaymentReceiptsListStateMaintainerEpic,
  bookingDiscussionItemsListStateMaintainerEpic,
  bookingActivityLogsListStateMaintainerEpic,
  suppliersListStateMaintainerEpic,
  customerPaymentMethodsListStateMaintainerEpic,
  supplierPaymentMethodsListStateMaintainerEpic,
  ledgersListStateMaintainerEpic,
  ledgerTransactionsListStateMaintainerEpic,
  brandsListStateMaintainerEpic
);
